import React from 'react';
import { DropdownItem, TrashIcon } from 'ui-components';

interface RemoveCreatorDropdownItemProps {
  onRemoveFromList: () => void;
}

export function RemoveCreatorDropdownItem({
  onRemoveFromList,
}: RemoveCreatorDropdownItemProps) {
  return (
    <DropdownItem onClick={onRemoveFromList}>
      <TrashIcon boxSize={4} />
      Remove from list
    </DropdownItem>
  );
}
